import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-neu-sm text-sm font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-luvcorp-gold/60 focus-visible:ring-offset-1 focus-visible:ring-offset-neu-base disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "neu-btn-primary",
        destructive: "neu-btn-destructive",
        outline: "neu-btn-base",
        secondary: "neu-btn-gold",
        ghost: "bg-transparent text-luvcorp-navy rounded-neu-sm hover:shadow-neu-outset-sm hover:bg-neu-base/60 active:shadow-neu-pressed transition-all",
        link: "text-luvcorp-navy underline-offset-4 hover:underline hover:text-luvcorp-gold",
      },
      size: {
        default: "h-10 px-5 py-2",
        sm: "h-8 px-3 text-xs rounded-neu-sm",
        lg: "h-11 px-8 rounded-neu-md",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
